export function setArrToLocalStorage<T>(key: string, arr: T[]): void {
  localStorage.setItem(key, JSON.stringify(arr));
}
